<template>
  <footer class="py-8 bg-transparent border-t border-gray-100 mt-auto animate__animated animate__fadeIn">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
        <div class="text-gray-400 text-xs font-medium tracking-wide">
          &copy; 2024 DIYPayroll Systems. All rights reserved.
        </div>
        
        <div class="flex items-center space-x-6">
          <router-link to="/privacy" class="text-gray-400 hover:text-[#0d47a1] text-xs font-bold transition-colors">Privacy Policy</router-link>
          <router-link to="/terms" class="text-gray-400 hover:text-[#0d47a1] text-xs font-bold transition-colors">Terms of Service</router-link>
          <router-link to="/security" class="text-gray-400 hover:text-[#0d47a1] text-xs font-bold transition-colors">Security</router-link>
          <a href="mailto:help@diypayroll.io" class="text-gray-400 hover:text-[#0d47a1] text-xs font-bold transition-colors">help@diypayroll.io</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    name: 'FooterComponent'
}
</script>

<style scoped>
    .animate__animated.animate__fadeIn {
        --animate-duration: 1s;
    }
</style>
